<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="getData"
          :total-data="totalRows"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="spkbForm"
          :generate-auto-spkb="autoGenerateManual"
          :redirect-detail="true"
          :show-add-button="true"
          :edit-button="editButton"
          :search-by-delivery-date="true"
          :search-by-customer="true"
          :busyx="busy"
          caption="<i class='fa fa-align-justify'></i> SPKB Listing"
          addButton="Buat SPKB"
          @generateAutoSPKB="generateAutoSPKB"
          @editForm="editForm"
          @isEdit="isEdit"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center">Form SPKB</h3>
          </div>

          <b-form id="spkbForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="driver" label="Driver">
                    <model-select
                      id="driver"
                      :options="listDriverEmployee"
                      v-model="$v.spkbForm.driver.$model"
                      :isError="$v.spkbForm.driver.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="spkbForm.driver === null"
                      class="invalid-feedback-custom"
                    >Konsumen harus di isi.</div>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="delivery_date" label="Tanggal Pengiriman">
                    <v-date-picker
                      id="delivery_date"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Pengiriman', required: ''}"
                      :state="!$v.spkbForm.delivery_date.$invalid"
                      v-model="$v.spkbForm.delivery_date.$model"
                    ></v-date-picker>
                    <div
                      v-if="$v.spkbForm.delivery_date.$invalid"
                      class="invalid-feedback-custom"
                    >Tanggal pengiriman harus di isi.</div>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="delivery_to" label="Tujuan Pengiriman">
                    <b-form-select
                      id="delivery_to"
                      :options="listSendTo"
                      @change="sendToChange($event)"
                      v-model="$v.spkbForm.delivery_to.$model"
                      :state="!$v.spkbForm.delivery_to.$invalid"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback>Tujuan pengiriman harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col sm="3" v-if="show_dc">
                  <b-form-group label-for="send_to_dc" label="Distribution Center">
                    <b-form-select
                      id="send_to_dc"
                      v-model="$v.spkbForm.send_to_dc.$model"
                      :state="!$v.spkbForm.send_to_dc.$invalid"
                      @change="selectInvoicePic($event)"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>

                      <option
                        v-for="(item, index) in listDistributionCenter"
                        :key="index"
                        :value="{value:item.dc_code, dc_id: item.value}"
                      >{{item.text}}</option>
                    </b-form-select>
                    <b-form-invalid-feedback>Distribution center harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="invoice_pic" label="Penanggung Jawab Faktur">
                    <b-form-select
                      id="invoice_pic"
                      v-model="$v.spkbForm.invoice_pic.$model"
                      :state="!$v.spkbForm.invoice_pic.$invalid"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                      <option
                        v-for="(item, index) in listDriverEmployee"
                        :key="index"
                        :value="{code:'employee', value:item.value}"
                      >{{item.text}}</option>
                      <option
                        v-for="(item, index) in listDistributionCenter"
                        :key="index+'a'"
                        :value="{code:'distribution_center', value:item.value}"
                      >{{item.text}}</option>
                    </b-form-select>
                    <b-form-invalid-feedback>Penanggung jawab faktur harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <!-- <b-col sm="3">
                   <b-form-group label-for="spkb_type" label="Tipe SPKB">
                    <model-select
                      id="spkb_type"
                      :options="listSpkbType"
                      v-model="$v.spkbForm.spkb_type.$model"
                      :isError="$v.spkbForm.spkb_type.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="spkbForm.spkb_type === null"
                      class="invalid-feedback-custom"
                    >SPKB Type harus di isi.</div>
                  </b-form-group>
                </b-col> -->
              </b-row>

              <!-- <b-row v-if="show_dc">
                <b-col sm="3">
                  <b-form-group label-for="send_to_dc" label="Distribution Center">
                    <b-form-select
                      id="send_to_dc"
                      v-model="$v.spkbForm.send_to_dc.$model"
                      :state="!$v.spkbForm.send_to_dc.$invalid"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>

                      <option
                        v-for="(item, index) in listDistributionCenter"
                        :key="index"
                        :value="{value:item.dc_code}"
                      >{{item.text}}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>-->
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="submitAdd"
                :disabled="$v.spkbForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import { required } from "vuelidate/lib/validators";
import globalTable from "../../templates/TableNew.vue";
import loading from "@/templates/Loading.vue";
import * as moment from "moment";

export default {
  name: "spkb",
  components: {
    globalTable,
    ModelSelect,
    loading
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      spkb: [],
      listDriverEmployee: [],
      listDistributionCenter: [],
      listCustomer: [],
      listSpkbType: [],
      listSendTo: [
        { value: "1", text: "Via DC" },
        { value: "2", text: "Langsung ke toko" }
      ],
      loading: true,
      loadingDropdown: false,
      loadingSubmitModal: false,
      spkbForm: interfaces.spkb,
      fields: [
        { key: "spkb_number", sortable: true },
        { key: "driver_name", label: "Nama Supir" },
        { key: "penanggung_jawab_faktur", label: "Penanggung Jawab Faktur" },
        { key: "delivery_date", label: "Tanggal Pengiriman", sortable: true },
        { key: "action_spkb", label: "Action", class: "text-center width-100" }
      ],
      show_dc: false,
      findCustomer: null,
      totalRows: "",
      findVal: false,
      busy: false,
      myDate: {
        end: new Date(),
        start: new Date(Date.now() - 86400000)
      },
      editButton: false
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {
    autoGenerateManual: function() {
      let division = localStorage.getItem("division_id");
      let nik = localStorage.getItem("nik");
      let nik_allowed = [];
      //let nik_allowed =  ['MBS19080018', 'MBS23110003', 'MBS23090002'];
      //this array nik allowed please refer to api /spkb/detail
      if(division === "13") {
        return true;
      } else {
        if(nik_allowed.includes(nik)) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  validations() {
    if (this.show_dc) {
      return {
        spkbForm: {
          delivery_date: { required },
          driver: { required },
          delivery_to: { required },
          send_to_dc: { required },
          invoice_pic: { required },
          spkb_type: {  }
        }
      };
    } else {
      return {
        spkbForm: {
          delivery_date: { required },
          driver: { required },
          delivery_to: { required },
          send_to_dc: {},
          invoice_pic: { required },
          spkb_type: { }
        }
      };
    }
  },
  methods: {
    getData: function(ctx) {
      this.loading = true;
      let response = axios.post('web/spkb/all', ctx);
      return response.then((data) => {
        const items = data.data.data;
        this.totalRows = data.data.total_rows;
        this.loading=false;
        this.editButton = data.data.edit_button;
        return(items)
      }).catch(error => {
        this.expired(error);
        this.loading=false;
        return []
      })
    },
    init: function() {
      //this.loading = true;
      //this.getAllSpkb();
      this.getDropdown();
    },
  
    getDropdown: function() {
      this.loadingDropdown = true;
      this.axios
        .get("web/dropdown/dropdown-spkb/active-driver-only")
        .then(response => {
          this.listDriverEmployee = response.data.driver;
          this.listDistributionCenter = response.data.distribution_center;
          this.listCustomer = response.data.customer;
          this.listSpkbType = response.data.spkb_type;
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loadingDropdown = false;
        });
    },
    editForm: function(a) {
      this.resetForm();
      this.spkbForm = a;
    },
    resetForm: function() {
      for (var a in interfaces.spkb) {
        interfaces.spkb[a] = null;
      }
      this.spkbForm = interfaces.spkb;
    },
    isEdit: function(flag) {
      return flag;
    },
    sendToChange: function(event) {
      this.spkbForm.send_to_dc = null;
      if (event === "1") {
        this.show_dc = true;
      } else {
        this.show_dc = false;
        this.spkbForm.invoice_pic = null;
      }
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (confirm("Do you want to insert new SPKB ?")) {
        this.loadingSubmitModal = true;
        this.axios
          .post("web/spkb/add/", this.spkbForm)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah SPKB",
                message: response.data.message
              });
            }
            this.$router.push({ path: "all/detail/" + response.data.id });
          })
          .catch(error => {
            this.expired(error, "Tambah SPKB");
          })
          .finally(() => {
            this.loadingSubmitModal = false;
          });
      }
    },
    selectInvoicePic: function(event) {
      this.spkbForm.invoice_pic = {
        code: "distribution_center",
        value: event.dc_id
      };
    },
    generateAutoSPKB: async function() {
      if (confirm("Apakah anda ingin meng-generate SPKB?")) {
        this.busy = true;
        this.axios
          .get("crawl/auto_generate_spkb/3/")
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Generate SPKB",
                message: response.data.message
              });
            }
          })
          .catch(error => {
            this.expired(error, "Generate SPKB");
          })
          .finally(() => {
            this.busy = false;
            this.init();
            this.loading = false;
          });
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>